export default "__VITE_PUBLIC_ASSET__efff850b__"